export interface MemberDiscountFormValues {
    enable: boolean
    frequency: number
    weekdays?: number[]
    monthdays?: number[]
    has_balance: boolean
    scenes?: number[]
    levels?: Array<{
        member_level_id?: number | null
        level?: number | null
        name: string
        discount_rate?: number | null
        origin_discount_rate?: number | null
        is_svip?: boolean
    }>
}

type MemberDiscountLevelValue = NonNullable<MemberDiscountFormValues['levels']>[number]

const hasValue = (value: any) => value !== '' && value !== undefined && value !== null

const getLevelName = (level: MemberDiscountLevelValue) => level.name || '该等级'

const isSvipLevel = (level: MemberDiscountLevelValue) =>
    level.is_svip || (level.member_level_id == null && level.level == null)

const getLevelOrder = (level: MemberDiscountLevelValue) =>
    isSvipLevel(level) ? Number.MAX_SAFE_INTEGER : Number(level.level ?? 0)

export const validateMemberDiscountLevels = (levels: MemberDiscountFormValues['levels'] = []) => {
    let hasConfiguredDiscount = false
    let previousOrdinaryLevel: MemberDiscountLevelValue | undefined
    let previousOrdinaryDiscountRate: number | undefined
    let hasBlankOrdinaryAfterConfigured = false

    for (const level of [...(levels || [])].sort((a, b) => getLevelOrder(a) - getLevelOrder(b))) {
        if (!hasValue(level.discount_rate)) {
            if (!isSvipLevel(level) && previousOrdinaryLevel) {
                if (hasValue(level.origin_discount_rate)) {
                    return `${getLevelName(level)}折扣需保持与${getLevelName(previousOrdinaryLevel)}折扣连续`
                }
                hasBlankOrdinaryAfterConfigured = true
            }
            continue
        }

        const discountRate = Number(level.discount_rate)
        if (Number.isNaN(discountRate) || discountRate <= 0 || discountRate >= 1) {
            return '会员折扣率必须大于0且小于1'
        }
        hasConfiguredDiscount = true

        if (isSvipLevel(level)) {
            if (
                previousOrdinaryLevel &&
                previousOrdinaryDiscountRate !== undefined &&
                discountRate > previousOrdinaryDiscountRate
            ) {
                return `${getLevelName(level)}折扣率不能高于${getLevelName(previousOrdinaryLevel)}折扣率`
            }
            continue
        }

        if (hasBlankOrdinaryAfterConfigured && previousOrdinaryLevel) {
            return `${getLevelName(level)}折扣需保持与${getLevelName(previousOrdinaryLevel)}折扣连续`
        }

        if (
            previousOrdinaryLevel &&
            previousOrdinaryDiscountRate !== undefined &&
            discountRate > previousOrdinaryDiscountRate
        ) {
            return `${getLevelName(level)}折扣率不能高于${getLevelName(previousOrdinaryLevel)}折扣率`
        }

        previousOrdinaryLevel = level
        previousOrdinaryDiscountRate = discountRate
    }

    return hasConfiguredDiscount ? '' : '请至少设置一个会员等级折扣'
}
